"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

export const ThemeReset = () => {
  const { setTheme, resolvedTheme } = useTheme();

  useEffect(() => {
    setTheme("light");
  }, [setTheme, resolvedTheme]);

  return null;
};
